export const userData = {
	id: 172259,
	name: 'Sravani Siripurapu',
	first_name: 'Sravani',
	last_name: 'Siripurapu',
	email: 'sravanisiripurapu888@gmail.com',
	email_verified: false,
	phone_verified: true,
	phonenumber: '647995044741',
	referral_code: 'ZPZAI4',
	referrer: null,
	is_active: true,
	verification_key: '',
	addresses: [
		{
			id: 146786,
			name: 'House',
			user: 172259,
			address1: '101-f',
			address2: 'vizianagaram',
			phonenumber: '7995044741',
			area: 64,
			landmark: 'skdjf',
			pincode: '534214',
			area_name: 'Madhapur',
			city: {
				id: 1,
				name: 'Chennai'
			},
			state: {
				id: 1,
				name: 'Tamil Nadu'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'vizianagaram'
		},
		{
			id: 146787,
			name: 'Korukonda',
			user: 172259,
			address1: '101-f',
			address2: 'Chinna Street',
			phonenumber: '7997166294',
			area: 64,
			landmark: 'Near ramalayam',
			pincode: '535214',
			area_name: 'Madhapur',
			city: {
				id: 1,
				name: 'Chennai'
			},
			state: {
				id: 1,
				name: 'Tamil Nadu'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'Chinna Street'
		},
		{
			id: 146788,
			name: 'restaurant',
			user: 172259,
			address1: 'Samba Foods',
			address2: 'takeaway',
			phonenumber: null,
			area: 66,
			landmark: null,
			pincode: '534247',
			area_name: 'Veeravasaram',
			city: {
				id: 1,
				name: 'Chennai'
			},
			state: {
				id: 1,
				name: 'Tamil Nadu'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: null
		},
		{
			id: 146789,
			name: 'restaurant',
			user: 172259,
			address1: 'Burger N Beast',
			address2: 'takeaway',
			phonenumber: null,
			area: 76,
			landmark: null,
			pincode: '901600',
			area_name: 'Dunedin',
			city: {
				id: 8,
				name: 'Dunedin'
			},
			state: {
				id: 6,
				name: 'Dunedin'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: null
		},
		{
			id: 146808,
			name: 'Testing',
			user: 172259,
			address1: 'asldkj',
			address2: 'asdasd',
			phonenumber: '7997166294',
			area: 74,
			landmark: 'asdasd',
			pincode: '535214',
			area_name: 'Dunedin',
			city: {
				id: 8,
				name: 'Dunedin'
			},
			state: {
				id: 6,
				name: 'Dunedin'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'asdasd'
		},
		{
			id: 146853,
			name: 'sad',
			user: 172259,
			address1: 'jshfjks',
			address2: 'sjdfhk',
			phonenumber: '985938453',
			area: 74,
			landmark: 'afkjshdf',
			pincode: '535214',
			area_name: 'Dunedin',
			city: {
				id: 8,
				name: 'Dunedin'
			},
			state: {
				id: 6,
				name: 'Dunedin'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'sjdfhk'
		},
		{
			id: 146854,
			name: 'ADD',
			user: 172259,
			address1: 'SDLF',
			address2: 'SJKDFH',
			phonenumber: '938493853534',
			area: 74,
			landmark: 'SJDKFH',
			pincode: '535214',
			area_name: 'Dunedin',
			city: {
				id: 8,
				name: 'Dunedin'
			},
			state: {
				id: 6,
				name: 'Dunedin'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'SJKDFH'
		},
		{
			id: 146855,
			name: 'akjdsh',
			user: 172259,
			address1: 'kjdfh',
			address2: 'sjkdfh',
			phonenumber: '87348274w',
			area: 74,
			landmark: 'skjfh',
			pincode: '535214',
			area_name: 'Dunedin',
			city: {
				id: 8,
				name: 'Dunedin'
			},
			state: {
				id: 6,
				name: 'Dunedin'
			},
			formatted_address: null,
			lat: null,
			lng: null,
			building: 'sjkdfh'
		}
	],
	account_balance: 0,
	is_guest: false,
	current_area: 76,
	username: '9CC0A85864F740C',
	current_place: null,
	last_active_on: '2020-08-12T17:24:01+05:30'
};

export const orderData = [
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'shipped' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'cancelled' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'cancelled' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'shipped' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'shipped' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' },
	{ name: 'DX-BHO-13275-27075', price: '560', items: 14, date: 'AUG 13 , 12:30AM', status: 'delivered' }
];
